<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
			<div>
                <v-row justify="center" >
                    <v-col class="text-center col-md-5">
                        <div class="font-weight-bold body-1">
                            Editar Proveedor
                        </div>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="12" md="5">
                        <v-form ref="form" @submit.prevent="save">
                            <item-form ref="SupplierForm" :values="form" @save="save" :serverErrors="serverErrors"></item-form>
                        </v-form>
                    </v-col>
                    
                </v-row>
            </div>

            <v-row justify="center" align="end">
				<v-col cols="12" md="5" class="">
                    <v-row justify="end" class="px-3 py-3">
                        <secondary-button data-cy="cancel-btn" :props="cancelBtnData" class="mr-0 mr-sm-2 mb-3 mb-sm-0"></secondary-button>
                        <primary-button data-cy="accept-btn" :props="saveBtnData" class=""></primary-button>  
                    </v-row>
				</v-col>
			</v-row>
        </template>
    </contentCard>
</template>

<script>
import Utils from '../../../helpers/Utils';
import SupplierForm from "./Form.vue";
export default {
    components: {
        'item-form': SupplierForm,
    },
	data(){
		return {
            loading: false,
            serverErrors: {},
            id: this.$route.params.id,
            form: {
                name: "",
                rfc: "",
                business_name: "",
                address_code: "",
                country: "",
                country_id: "",
                state: "",
                state_id: "",
                city: "",
                neighborhood: "",
                street: "",
                ext_number: "",
                int_number: "",
                contact: "",
                phone: "",
                email: "",
                supplies: "",
                supplies_materia:false,
                supplies_consumable:false,
                supplies_indirect:false,
                    
            },
            cancelBtnData: {
                text: "Cancelar",
                icon: "",
                to: "Suppliers",
                block:false,
                click: () => {}
            },
            saveBtnData: {
                text: "Guardar",
                icon: "",	
                click: this.save,
                block:false,
                loading: false,
            },
            snackbarProps: {
                visible: false,
				color: 'success',
				timeout: 3000,
				text: '',
            },
		}
    },
    mounted(){
        this.index();
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
        
    },
	methods: {
        index(){
            this.loading = true;
            this.$store.state.loading = true;
            this.$api.supplier.get(this.id)
                .then((resp) => {
                    // let permi = [];
                    this.form = {...this.form,...resp.data};
                    if(resp.data.supplies.includes("Materia Prima"))
                        this.form.supplies_materia = true;
                    if(resp.data.supplies.includes("Consumibles"))
                        this.form.supplies_consumable = true;
                    if(resp.data.supplies.includes("Indirectos"))
                        this.form.supplies_indirect = true;

                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                    this.$store.state.loading = false;
                })
            ;
        },
       
        onResize () {
            
            if(window.innerWidth < 600){
                this.saveBtnData.block = true;
                this.cancelBtnData.block = true;
            }
            else{
                this.saveBtnData.block = false;
                this.cancelBtnData.block = false;
            }
        },
		validate () {
            if(!Utils.objectIsEmpty(this.serverErrors))
                return false;
			return this.$refs.form.validate();
            // return true;
		},
        save(){
            
            console.log(this.form);
            
            if(this.validate()){
                
                let form = this.prepareRequest(this.form);
                this.saveBtnData.loading = true;
                this.$store.state.loading = true;
                this.$api.supplier.update(this.id, form)
                    .then(() => {
                        //console.log(response)

                        this.$store.dispatch('snackbarSuccess', `Se ha actualizado correctamente`);
                        this.$router.push({name: 'Suppliers'});
                    })
                    .catch((error) => {
                        var errors = []
                        switch(error.response.status){
                            case 422: 
                                
                                if(("error" in error.response.data)){
                                    if(error.response.data.error instanceof Object){
                                        Object.keys(error.response.data.error).forEach((x) => {
                                            
                                               
                                            console.log(x);
                                            this.serverErrors = error.response.data.error;
                                            error.response.data.error[x].forEach((y) => {
                                                this.serverErrors[x] = Utils.deleteWord(x,y);
                                                errors.push(Utils.deleteWord(x,y))
                                            })
                                        });
                                    }else{
                                        errors.push(error.response.data.error)
                                    }
                                    
                                    this.$store.dispatch('snackbarError', errors.join('.<br>'));
                                }
                               
                            break;
                           
                        }
                        console.log(this.serverErrors)
                       
                    })
                    .finally(() => {
                        this.saveBtnData.loading = false;
                        this.$store.state.loading = false;
                    })
                ;
            }else{
                
                this.$store.dispatch('snackbarError', `Formulario incompleto`);
            }
            // eslint-disable-next-line no-console
        },
        prepareRequest(request)
        {
            //Materia prima,Consumibles,Indirectos
            let data = JSON.parse(JSON.stringify(request));
            data.supplies = "";
            // form.supplies = form.supplies.join(',')
            if(data.supplies_materia)
                data.supplies = "Materia Prima";
            if(data.supplies_consumable)
                data.supplies = data.supplies + ",Consumibles";
            if(data.supplies_indirect)
                data.supplies = data.supplies + ",Indirectos";

           
            data.supplies = data.supplies.indexOf(',') == 0 ?  data.supplies.substring(1) :  data.supplies;
           
           
            return data;
        }
    },
}
</script>

<style>

</style>